import Components from "./config/components";

export default [
  {
    name: "Home",
    path: "/",
    component: Components.Home,
    meta: {},
  },
  {
    name: "PersonalCredit",
    path: "/rata",
    component: Components.PersonalCredit,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmailPrivacy",
    path: "/email-privacy",
    component: Components.EmailPrivacy,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Contacts",
    path: "/contatti",
    component: Components.Contacts,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PersonalData",
    path: "/anagrafica",
    component: Components.PersonalData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IncomeData",
    path: "/reddito",
    component: Components.IncomeData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmployerData",
    path: "/lavoro",
    component: Components.EmployerData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubConsent",
    path: "/club",
    component: Components.ClubConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubWarning",
    path: "/club-avviso",
    component: Components.ClubWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "DeliveryData",
    path: "/residenza",
    component: Components.DeliveryData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IdentityDocData",
    path: "/documento",
    component: Components.IdentityDocData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PaymentData",
    path: "/iban",
    component: Components.PaymentData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Promo",
    path: "/promo",
    component: Components.Promo,
    meta: {
      redirect: true,
    },
  },
  {
    path: "/typ",
    name: "Typ",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    path: "/ko",
    name: "TypKO",
    component: Components.TypKO,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
];
